import { useEffect } from 'react'
import useModal from '@/hooks/useModal'
import { ShowModalType } from '@/scenes/engine/common/constants'
import { handleContactUs } from '@/utils/contactUs'
import { useHistory } from 'react-router-dom'
import { setShowModalCustomText } from '@/store/slices/modal/customTextModal'

function ModalProjectOpenFailed() {
  const { showModalType, setShowModalType } = useModal()
  const history = useHistory()

  useEffect(() => {
    if (showModalType !== ShowModalType.PROJECT_OPEN_FAILED) return
    setShowModalCustomText(
      'Can’t open this project',
      'Please contact Bazaart support.',
      'Contact us',
      'Cancel',
      true,
      () => {
        handleContactUs('Can’t save this project', undefined, 'Project Failed to Open')
        history.replace('/create/projects')
      },
      () => {
        setShowModalType(null)
        history.replace('/create/projects')
      }
    )
  }, [showModalType, setShowModalType, history])

  return null
}

export default ModalProjectOpenFailed
